import { useState, useEffect } from 'react';
import { useLocation, useNavigate, Outlet } from 'react-router';

const steps = [
  { label: 'Leads', href: '/leads' },
  { label: 'Draft Emails', href: '/draft-emails' },
  { label: 'Review & Send', href: '/review-send' },
];

function getCurrentStep(pathname: string): 1 | 2 | 3 {
  if (pathname.startsWith('/draft-emails')) return 2;
  if (pathname.startsWith('/review-send')) return 3;
  return 1;
}

export function OutreachLayout() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const currentStep = getCurrentStep(pathname);

  // Defer sessionStorage reads to after mount to avoid mismatch
  const [mounted, setMounted] = useState(false);
  const [completedSteps, setCompletedSteps] = useState<Set<number>>(new Set());

  useEffect(() => {
    setMounted(true);
  }, []);

  useEffect(() => {
    if (!mounted) return;
    const completed = new Set<number>();
    if (sessionStorage.getItem('selectedGroupId')) completed.add(1);
    if (sessionStorage.getItem('draftsGenerated') === 'true') completed.add(2);
    setCompletedSteps(completed);
  }, [mounted, pathname]);

  return (
    <div className="max-w-6xl mx-auto w-full">
      <ul className="steps steps-horizontal w-full mb-[50px]">
        {steps.map((step, i) => {
          const stepNum = (i + 1) as 1 | 2 | 3;
          const isActive = stepNum === currentStep;
          const isCompleted = mounted && completedSteps.has(stepNum) && stepNum < currentStep;
          const colorClass = isCompleted || isActive ? 'step-primary' : '';

          return (
            <li
              key={stepNum}
              data-content={isCompleted ? '✓' : stepNum}
              className={`step ${colorClass} text-sm cursor-pointer ${isActive ? 'font-semibold' : ''}`}
              onClick={() => navigate(step.href)}
            >
              {step.label}
            </li>
          );
        })}
      </ul>
      <Outlet />
    </div>
  );
}
